import React from 'react'
import {
  RightPanel,
  DetailHeader,
  DetailTitle,
  EmptyState,
  AssignmentTable,
  TableHead,
  TableBody,
  PrimaryButton,
  DangerButton,
} from '../../screens/features.styled'

function FeatureDetail({feature, onAddRule, onRemoveClick, hasWriteAccess}) {
  if (!feature) {
    return (
      <RightPanel>
        <EmptyState>Select a feature to view its rules</EmptyState>
      </RightPanel>
    )
  }

  return (
    <RightPanel>
      <DetailHeader>
        <DetailTitle>{feature.featureDesc}</DetailTitle>
        {hasWriteAccess && (
          <PrimaryButton onClick={onAddRule}>+ Add Rule</PrimaryButton>
        )}
      </DetailHeader>
      <AssignmentTable>
        <TableHead>
          <tr>
            <th>Type</th>
            <th>Value</th>
            {hasWriteAccess && <th>Action</th>}
          </tr>
        </TableHead>
        <TableBody>
          {feature.assignments.map(assignment => (
            <tr key={assignment.id}>
              <td>{assignment.entityType}</td>
              <td>{assignment.entityValue}</td>
              {hasWriteAccess && (
                <td>
                  <DangerButton onClick={() => onRemoveClick(assignment)}>
                    Remove
                  </DangerButton>
                </td>
              )}
            </tr>
          ))}
        </TableBody>
      </AssignmentTable>
    </RightPanel>
  )
}

export {FeatureDetail}
